import React from "react";
import { Switch } from "@cdkglobal/radial";
import { RowData, RowDataReducerAction } from "../../../../../types";
import { useUIStateContext } from "../../../../../contexts/UIStateContext";
import { useUserContext } from "../../../../../contexts/UserContext";
import { TOAST_MESSAGES } from "../../../constants";
import styled from "styled-components";

const SwitchWrapper = styled.div`
  margin-right: -1.75rem;
  flex-shrink: 0;

  label {
    white-space: nowrap;
  }
`;

export function ActiveSwitch({
  active,
  id,
  rowData,
  dispatch,
}: {
  readonly active: boolean;
  readonly id: string;
  readonly rowData: RowData;
  readonly dispatch: React.Dispatch<RowDataReducerAction>;
}) {
  const { incrementSaveRequestId, setLandingPageToast } = useUIStateContext();
  const { permissions } = useUserContext();

  const onChange = () => {
    setLandingPageToast(TOAST_MESSAGES.SAVING());
    dispatch({
      type: "UPDATE_ROW_DATA_REDUCER_STATE",
      payload: { rowData: { ...rowData, is_enabled: !rowData.is_enabled } },
    });
    incrementSaveRequestId();
  };

  return (
    <SwitchWrapper
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <Switch
        dataTestId={`active-toggle-${id}`}
        id={`active-toggle-${id}`}
        label={active ? "Active" : "Inactive"}
        checked={active}
        labelPosition="AFTER"
        name="active"
        onChange={onChange}
        size="small"
        isDisabled={!permissions.setupPermission.hasManage}
      />
    </SwitchWrapper>
  );
}
